module.exports = __webpack_public_path__ + "img/sgtl_logo.6a043aa4.png";